export const CODE_PASSWORD_CHANGE_REQUIRED = 105574;